<template>
  <el-form :model="form" label-width="95px" :disabled="mode === 'view'">
    <el-form-item label="网格">
      <el-input-number
        v-model="form.gridSize"
        :controls="false"
        :min="5"
        class="w-full"
        @change="globalChange"
      />
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  props: ['configData', 'mode'],
  data() {
    return {
      form: {
        gridSize: 10, // 网格大小
      },
    }
  },
  watch: {
    configData: {
      deep: true,
      immediate: true,
      handler(val) {
        this.form = this.$options.data().form
        if (!_.isEmpty(val)) {
          _.assign(this.form, val)
        } else {
          this.globalChange()
        }
      },
    },
  },
  methods: {
    globalChange() {
      this.$emit('globalChange', this.form)
    },
  },
  created() {},
}
</script>

<style></style>
